export const generateYears = (firstYear)=>{
    let years = [];
    let startYear = firstYear || 2023;
    let currentYear = new Date().getFullYear()
    for(let i=startYear; i <= currentYear; i++){
        years.push(i);
    }
    return years;
}